import React from 'react';

type IconProps = {
    color?: string;
    width?: number;
    height?: number;
};

const IconEmojiEmotional: React.FC<IconProps> = ({ color, width = 13, height = 13 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
        >
            <g clip-path="url(#clip0_5359_16909)">
                <path
                    d="M6 12C2.69175 12 0 9.30825 0 6C0 2.69175 2.69175 0 6 0C9.30825 0 12 2.69175 12 6C12 9.30825 9.30825 12 6 12ZM6 0.75C3.105 0.75 0.75 3.105 0.75 6C0.75 8.895 3.105 11.25 6 11.25C8.895 11.25 11.25 8.895 11.25 6C11.25 3.105 8.895 0.75 6 0.75ZM3.375 9.375C2.92275 9.375 2.25 9.07537 2.25 8.25C2.25 7.36987 3.02175 6.57262 3.10988 6.48487C3.2505 6.34425 3.4995 6.34425 3.64012 6.48487C3.72825 6.57262 4.5 7.36987 4.5 8.25C4.5 9.07537 3.82725 9.375 3.375 9.375ZM3.375 7.33538C3.19125 7.5915 3 7.93913 3 8.25C3 8.55225 3.20625 8.6205 3.3795 8.625C3.54375 8.6205 3.75 8.55225 3.75 8.25C3.75 7.93913 3.55875 7.5915 3.375 7.33538ZM5.25038 9C5.12925 9 5.01038 8.9415 4.938 8.83313C4.82325 8.66063 4.86975 8.42812 5.04187 8.313C6.2475 7.509 7.44938 7.5 7.5 7.5C7.70738 7.5 7.875 7.66762 7.875 7.875C7.875 8.082 7.70775 8.24963 7.50113 8.25C7.47975 8.25037 6.46163 8.268 5.45813 8.937C5.394 8.97937 5.32163 9 5.25038 9ZM7.875 6.375C7.66762 6.375 7.5 6.20738 7.5 6V4.5C7.5 4.293 7.66762 4.125 7.875 4.125C8.08237 4.125 8.25 4.293 8.25 4.5V6C8.25 6.20738 8.08237 6.375 7.875 6.375ZM4.125 6.375C3.918 6.375 3.75 6.20738 3.75 6V4.5C3.75 4.293 3.918 4.125 4.125 4.125C4.332 4.125 4.5 4.293 4.5 4.5V6C4.5 6.20738 4.332 6.375 4.125 6.375Z"
                    fill="#682FDC"
                />
            </g>
            <defs>
                <clipPath id="clip0_5359_16909">
                    <rect width="12" height="12" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconEmojiEmotional;
